'use client';

import { useState } from 'react';
import utilsStyles from '../../../../styles/modules/utils.module.scss';
import type { VariantType } from '../../../../types';
import type { NotificationItem } from '../../types';
import styles from './NotificationList.module.scss';

/*:
 * 通知一覧
 * デザイン共通
 */
export interface NotificationListProps {
  items: Array<NotificationItem>;
  values: number[];
  InputSwitchComponent: React.ComponentType<{
    name: string;
    inputValue: number;
    onChange: () => void;
    checked: boolean;
    reversed?: boolean;
  }>;
  onSubmit: (permission: number) => Promise<void>;
  variant?: VariantType;
}

function NotificationList({ items, values, InputSwitchComponent, onSubmit }: NotificationListProps) {
  const [checkList, setCheckList] = useState(values);
  const currentStyles = styles;

  const handleToggle = (value: number) => {
    let changed: number[];
    if (checkList.includes(value)) {
      changed = checkList.filter((check) => check !== value);
    } else {
      changed = [...checkList, value];
    }
    const permission = changed.reduce((a, b) => Number(a) + Number(b), 0);
    setCheckList(changed);
    onSubmit(permission);
  };

  return (
    <ul className={currentStyles.notificationList}>
      {items.map((v) => (
        <li key={v.value}>
          <div className={currentStyles.itemBlock}>
            <div className={currentStyles.itemDetail}>
              <p className={`${utilsStyles.textSmall} ${utilsStyles.textBold}`}>{v.title}</p>
              <p className={utilsStyles.textXSmall}>{v.description}</p>
            </div>
            <div>
              <InputSwitchComponent
                name='notification'
                inputValue={v.value}
                onChange={() => {
                  handleToggle(v.value);
                }}
                checked={checkList.includes(v.value)}
                reversed={true}
              />
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
}

export default NotificationList;
